//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavigationItem from '~sdp-components/Navigation/NavigationItem'

export default {
  components: {
    NavigationItem,
  },
  computed: {
    schoolReportRoute() {
      const slugReport = this.$store.state.selections.slugReport
      if (slugReport.length) {
        return '/report/' + slugReport
      } else {
        return '/report'
      }
    },
    schoolCalculatorRoute() {
      const slugReport = this.$store.state.selections.slugReport
      if (slugReport) {
        return '/calculator/' + slugReport
      } else {
        return '/calculator'
      }
    },
  },
}
